import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Input,
  Table,
  Space,
  Popconfirm,
  Col,
  Row,
  Tooltip,
  Form,
  Button,
} from "antd";
import { getRequest, postRequest } from "../../axios";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import scan_unchecked_red from "../../image/scan_unchecked_red.png";
import scan_check_green from "../../image/scan_check_green.png";
import { debounce } from "lodash";
import ButtonField from "../../common/htmlComponents/ButtonField";
import SearchIcon from "../../image/SearchIcon.svg";
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import moment from "moment";
import { authUserData } from "../../utils/Helper";
import { UndoOutlined } from "@ant-design/icons";
const { Search } = Input;

const ArchivePackage = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [archivedEmployeeList, setArchivedEmployeeList] = useState([]);
  const PickupPointId = authUserData()?.pickup_point
    ? authUserData()?.pickup_point
    : "";
  const CompanyId = authUserData()?.company ? authUserData()?.company : "";
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 300,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getEmployeeArchiveList = async () => {
      setLoading(true);
      try {
        // let apiResponse = await getRequest(`employee-archive/?company_id=${CompanyId}`, state);
        let apiResponse = await getRequest(
          `package-model/archived-package-model-list/?company_id=${CompanyId}&pickup_point_id=${PickupPointId}&is_picked_up=${true}`,
          state
        );

        if (apiResponse.status) {
          const sortedData = apiResponse.data.results.sort((a, b) => {
            return a.id - b.id;
          });

          setArchivedEmployeeList(sortedData);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getEmployeeArchiveList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    // const start = (pagination.current - 1) * pagination.pageSize;
    // const end = start + pagination.pageSize;

    // const newSelectedRows = [...selectedRow.slice(0, start), ...selectedRow.slice(end)];
    // setSelectedRow(newSelectedRows);
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "parcel_no" && sortOrder === "ascend") {
      sortingEnumKey = "parcel_no";
    }
    if (sortField === "parcel_no" && sortOrder === "descend") {
      sortingEnumKey = "-parcel_no";
    }
    if (sortField === "sequence_no" && sortOrder === "ascend") {
      sortingEnumKey = "sequence_no";
    }
    if (sortField === "sequence_no" && sortOrder === "descend") {
      sortingEnumKey = "-sequence_no";
    }

    if (sortField === "hawb" && sortOrder === "ascend") {
      sortingEnumKey = "hawb";
    }
    if (sortField === "hawb" && sortOrder === "descend") {
      sortingEnumKey = "-hawb";
    }

    if (sortField === "created_at" && sortOrder === "ascend") {
      sortingEnumKey = "created_at";
    }
    if (sortField === "created_at" && sortOrder === "descend") {
      sortingEnumKey = "-created_at";
    }

    if (sortField === "is_scanned" && sortOrder === "ascend") {
      sortingEnumKey = "is_scanned";
    }
    if (sortField === "is_scanned" && sortOrder === "descend") {
      sortingEnumKey = "-is_scanned";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb__area";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb__area";
    }
    if (sortField === "zone" && sortOrder === "ascend") {
      sortingEnumKey = "zone__zone";
    }
    if (sortField === "zone" && sortOrder === "descend") {
      sortingEnumKey = "-zone__zone";
    }
    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "postcode" && sortOrder === "ascend") {
      sortingEnumKey = "postcode__pincode";
    }
    if (sortField === "postcode" && sortOrder === "descend") {
      sortingEnumKey = "-postcode__pincode";
    }
    if (sortField === "assigned_to" && sortOrder === "ascend") {
      sortingEnumKey = "assign_package__driver__name";
    }
    if (sortField === "assigned_to" && sortOrder === "descend") {
      sortingEnumKey = "-assign_package__driver__name";
    }
    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }
    if (sortField === "customer_code" && sortOrder === "ascend") {
      sortingEnumKey = "customer_code";
    }
    if (sortField === "customer_code" && sortOrder === "descend") {
      sortingEnumKey = "-customer_code";
    }
    if (sortField === "customer_name" && sortOrder === "ascend") {
      sortingEnumKey = "customer_name";
    }
    if (sortField === "customer_name" && sortOrder === "descend") {
      sortingEnumKey = "-customer_name";
    }
    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_name";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_name";
    }
    if (sortField === "customer_address" && sortOrder === "ascend") {
      sortingEnumKey = "customer_address";
    }
    if (sortField === "customer_address" && sortOrder === "descend") {
      sortingEnumKey = "-customer_address";
    }
    if (sortField === "description_of_goods" && sortOrder === "ascend") {
      sortingEnumKey = "description_of_goods";
    }
    if (sortField === "description_of_goods" && sortOrder === "descend") {
      sortingEnumKey = "-description_of_goods";
    }
    if (sortField === "count" && sortOrder === "ascend") {
      sortingEnumKey = "count";
    }
    if (sortField === "count" && sortOrder === "descend") {
      sortingEnumKey = "-count";
    }
    if (sortField === "landed" && sortOrder === "ascend") {
      sortingEnumKey = "landed";
    }
    if (sortField === "landed" && sortOrder === "descend") {
      sortingEnumKey = "-landed";
    }
    if (sortField === "weight" && sortOrder === "ascend") {
      sortingEnumKey = "weight";
    }
    if (sortField === "weight" && sortOrder === "descend") {
      sortingEnumKey = "-weight";
    }
    if (sortField === "shipper_code" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_code";
    }
    if (sortField === "shipper_code" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_code";
    }
    if (sortField === "shipper_name" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_name";
    }
    if (sortField === "shipper_name" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_name";
    }
    if (sortField === "shipper_address" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_address";
    }
    if (sortField === "shipper_address" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_address";
    }
    if (sortField === "shipper_city" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_city";
    }
    if (sortField === "shipper_city" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_city";
    }
    if (sortField === "shipper_state" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_state";
    }
    if (sortField === "shipper_state" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_state";
    }
    if (sortField === "shipper_postcode" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_postcode";
    }
    if (sortField === "shipper_postcode" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_postcode";
    }
    if (sortField === "shipper_country" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_country";
    }
    if (sortField === "shipper_country" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_country";
    }
    if (sortField === "origin" && sortOrder === "ascend") {
      sortingEnumKey = "origin";
    }
    if (sortField === "origin" && sortOrder === "descend") {
      sortingEnumKey = "-origin";
    }
    if (sortField === "port" && sortOrder === "ascend") {
      sortingEnumKey = "port";
    }
    if (sortField === "port" && sortOrder === "descend") {
      sortingEnumKey = "-port";
    }
    if (sortField === "total_value" && sortOrder === "ascend") {
      sortingEnumKey = "total_value";
    }
    if (sortField === "total_value" && sortOrder === "descend") {
      sortingEnumKey = "-total_value";
    }
    if (sortField === "goods_currency" && sortOrder === "ascend") {
      sortingEnumKey = "goods_currency";
    }
    if (sortField === "goods_currency" && sortOrder === "descend") {
      sortingEnumKey = "-goods_currency";
    }
    if (sortField === "sac" && sortOrder === "ascend") {
      sortingEnumKey = "sac";
    }
    if (sortField === "sac" && sortOrder === "descend") {
      sortingEnumKey = "-sac";
    }
    if (sortField === "sub_master" && sortOrder === "ascend") {
      sortingEnumKey = "sub_master";
    }
    if (sortField === "sub_master" && sortOrder === "descend") {
      sortingEnumKey = "-sub_master";
    }
    if (sortField === "pkg_type" && sortOrder === "ascend") {
      sortingEnumKey = "pkg_type";
    }
    if (sortField === "pkg_type" && sortOrder === "descend") {
      sortingEnumKey = "-pkg_type";
    }
    if (sortField === "cyber_vendor_account" && sortOrder === "ascend") {
      sortingEnumKey = "cyber_vendor_account";
    }
    if (sortField === "cyber_vendor_account" && sortOrder === "descend") {
      sortingEnumKey = "-cyber_vendor_account";
    }
    if (sortField === "customs_code" && sortOrder === "ascend") {
      sortingEnumKey = "customs_code";
    }
    if (sortField === "customs_code" && sortOrder === "descend") {
      sortingEnumKey = "-customs_code";
    }
    if (sortField === "fr_reference" && sortOrder === "ascend") {
      sortingEnumKey = "fr_reference";
    }
    if (sortField === "fr_reference" && sortOrder === "descend") {
      sortingEnumKey = "-fr_reference";
    }
    return sortingEnumKey;
  };

  // const handleStatus = async (user_id, status) => {
  //   confirmAlert({
  //     title: t("confirmAlert_title"),
  //     message: t("confirmAlert_message"),
  //     buttons: [
  //       {
  //         label: t("confirmAlert_ok"),
  //         onClick: () => changeStatus(user_id, status),
  //       },
  //       {
  //         label: t("confirmAlert_cancel"),
  //         onClick: () => navigate("/employee/archive"),
  //       },
  //     ],
  //   });
  // };

  // const changeStatus = async (id, value) => {
  //   await patchRequest(`employee-status/${id}/`, { status: value })
  //     .then((response) => {
  //       SuccessNotificationMsg(t("status_updated_sucessfully"));
  //       setReload(!reload);
  //       setLoading(false);
  //     })
  //     .catch((error) => {});
  // };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });
    // setState({
    //   ...state,
    //   search: "",
    //   status: "",
    //   page: 1,
    // });
    form.setFieldsValue({ search: "" });
  };
  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {},
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest(
        "package-model/restore-package-model/",
        {
          deleted: ids,
        }
      );
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("package_restore_successfully"));
        setReload(!reload);
        navigate("/package");
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_restore_package"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "Parcel Number",
      dataIndex: "parcel_no",
      key: "parcel_no",
      sorter: true,
      width: 100,
    },
    {
      title: "Sequence",
      dataIndex: "sequence_no",
      key: "sequence_no",
      sorter: true,
      width: 150,
      render: (text) => (
        <div className="text-ellipsis">
          {text !== undefined && text !== null ? text : 0}
        </div>
      ),
    },
    {
      title: "HAWB",
      dataIndex: "hawb",
      key: "hawb",
      sorter: true,
      width: 200,
    },

    {
      title: "Schedule Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: true,
      width: 150,
      render: (text) => (
        // <Tooltip title={text}>
        //   <div className="text-ellipsis">
        //     {moment(text).format("DD-MM-YYYY")}
        //   </div>
        // </Tooltip>
        // <Tooltip title={text}>
        <div className="text-ellipsis">
          {text ? moment(text, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY") : "-"}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Is Scanned",
      dataIndex: "is_scanned",
      key: "is_scanned",
      sorter: true,
      width: 120,
      render: (text) => (
        <div className="text-ellipsis">
          {text ? (
            <img
              src={scan_check_green} // Replace with the actual path to the 'Yes' image
              alt="Yes"
              style={{ width: 20, height: 20, Color: "rgba(0, 128, 0, 0.5)" }}
            />
          ) : (
            <img
              src={scan_unchecked_red} // Replace with the actual path to the 'No' image
              alt="No"
              style={{ width: 20, height: 20 }}
            />
          )}
        </div>
      ),
    },

    {
      title: "Suburb",
      dataIndex: "suburb_name",
      key: "suburb",
      sorter: true,
      width: 180,
    },
    {
      title: "Run",
      dataIndex: "zone_name",
      key: "zone",
      sorter: true,
      width: 180,
    },
    {
      title: "State",
      dataIndex: "state_name",
      key: "state",
      sorter: true,
      width: 150,
    },
    {
      title: "Postcode",
      dataIndex: "postcode_name",
      key: "postcode",
      sorter: true,
      width: 150,
    },
    {
      title: "Company",
      dataIndex: "company_name",
      key: "company",
      sorter: true,
      width: 150,
    },
    {
      title: "Customer Code",
      dataIndex: "customer_code",
      key: "customer_code",
      sorter: true,
      width: 150,
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      sorter: true,
      width: 150,
    },
    {
      title: "Customer Phone",
      dataIndex: "customer_phone",
      key: "customer_phone",
      render: (customer_phone) => <>+{customer_phone} </>,
      sorter: true,
      width: 150,
    },
    {
      title: "Customer Address",
      dataIndex: "customer_address",
      key: "customer_address",
      sorter: true,
      width: 200,
      // render: (text) => (
      //   <Tooltip title={text}>
      //     <span>{text}</span>
      //   </Tooltip>
      // ),
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Description of Goods",
      dataIndex: "description_of_goods",
      key: "description_of_goods",
      sorter: true,
      width: 150,
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
      sorter: true,
      width: 100,
    },
    {
      title: "Landed",
      dataIndex: "landed",
      key: "landed",
      sorter: true,
      width: 100,
      render: (text) => (
        <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
      ),
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "weight",
      sorter: true,
      width: 100,
    },
    {
      title: "Shipper Code",
      dataIndex: "shipper_code",
      key: "shipper_code",
      sorter: true,
      width: 150,
    },
    {
      title: "Shipper Name",
      dataIndex: "shipper_name",
      key: "shipper_name",
      sorter: true,
      width: 150,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Shipper Address",
      dataIndex: "shipper_address",
      key: "shipper_address",
      sorter: true,
      width: 200,
      // render: (text) => (
      //   <Tooltip title={text}>
      //     <span>{text}</span>
      //   </Tooltip>
      // ),
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Shipper City",
      dataIndex: "shipper_city",
      key: "shipper_city",
      sorter: true,
      width: 150,
    },
    {
      title: "Shipper State",
      dataIndex: "shipper_state",
      key: "shipper_state",
      sorter: true,
      width: 150,
    },
    {
      title: "Shipper Postcode",
      dataIndex: "shipper_postcode",
      key: "shipper_postcode",
      sorter: true,
      width: 100,
    },
    {
      title: "Shipper Country",
      dataIndex: "shipper_country",
      key: "shipper_country",
      sorter: true,
      width: 150,
    },
    {
      title: "Origin",
      dataIndex: "origin",
      key: "origin",
      sorter: true,
      width: 150,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Port",
      dataIndex: "port",
      key: "port",
      sorter: true,
      width: 150,
    },
    {
      title: "Total Value",
      dataIndex: "total_value",
      key: "total_value",
      sorter: true,
      width: 150,
    },
    {
      title: "Goods Currency",
      dataIndex: "goods_currency",
      key: "goods_currency",
      sorter: true,
      width: 100,
    },
    {
      title: "SAC",
      dataIndex: "sac",
      key: "sac",
      sorter: true,
      width: 100,
      render: (text) => (
        <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
      ),
    },
    {
      title: "FR Reference",
      dataIndex: "fr_reference",
      key: "fr_reference",
      sorter: true,
      width: 150,
    },
    {
      title: "Sub Master",
      dataIndex: "sub_master",
      key: "sub_master",
      sorter: true,
      width: 150,
    },
    {
      title: "Package Type",
      dataIndex: "pkg_type",
      key: "pkg_type",
      sorter: true,
      width: 100,
    },
    {
      title: "Cyber Vendor Account",
      dataIndex: "cyber_vendor_account",
      key: "cyber_vendor_account",
      sorter: true,
      width: 150,
    },
    {
      title: "Customs Code",
      dataIndex: "customs_code",
      key: "customs_code",
      sorter: true,
      width: 150,
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Restore</span>}
          > */}
          <Popconfirm
            className="action"
            title={t("pop_restore_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleRestore(record.id)}
          >
            <ArchiveRestore className="ArchiverestorImg" />
          </Popconfirm>
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ];
  const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Archived Entries Retain Historical Data And Can Be Reinstated
                  If Necessary.
                </span>
              }
            > */}
            <h3>{t("archived_package_list")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/package">{t("Package")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("archiveList")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            {" "}
            <div className="searchwrp" style={{ height: "40px" }}>
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                      style={{
                        width: 250,
                      }}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  type="primary"
                  htmlType="button"
                  label="Restore"
                  className="BlueShadowBtn"
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="PR-body">
          <Row className="tblheader">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="tbl-heading"
            ></Col>
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 200,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  type="primary"
                  htmlType="button"
                  label="Restore"
                  className="BlueShadowBtn"
                />
              </Popconfirm>
            )}
          </Col> */}
          </Row>

          <Table
            scroll={{
              x: 2500,
            }}
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={archivedEmployeeList}
            loading={loading}
            pagination={{
              current: state.page, // Bind to state.page
              pageSize: state.pagesize, // Bind to state.pagesize
              pageSizeOptions: [
                "10",
                "50",
                "100",
                "200",
                "300",
                "400",
                "500",
                "600",
                "700",
                "800",
                "900",
                "1000",
              ],
              onShowSizeChange: (current, pageSize) => {
                setState((prevState) => ({
                  ...prevState,
                  pagesize: pageSize,
                  page: current,
                }));
              },
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: { items_per_page: "Items / Page" },
            }}
            onChange={handleTableChange}
          />
          <div className="FormFooter Container">
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("previous")}
              onClick={() => navigate(`/package`)}
              //onClick={() => setCurrentIndex(0)}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ArchivePackage;
